import React, { useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import clsx from 'clsx'
import Text from './soWurdeBewertet.mdx'
import s from './assessment.m.scss'
import { MDXProvider } from '@mdx-js/react'

const components = {
  ul: props => <div className={s.list} {...props} />,
  li: props => (
    <div className={s.item}>
      <i className={s.icon} />
      <div className={s.content} {...props} />{' '}
    </div>
  ),
  h3: props => <h3 className={s.header} {...props} />
}

export function Assessment() {
  const [isActive, setActive] = useState(false)

  return (
    <div className={clsx(s.assessment)}>
      <h2
        className={clsx(isActive && 'active', s.title)}
        onClick={() => setActive(prevState => !prevState)}
      >
        <i className='dropdown icon' />
        So wurde bewertet
      </h2>
      <div className={clsx('content', isActive && 'active')}>
        <MDXProvider components={components}>
          <Text />
        </MDXProvider>
      </div>
    </div>
  )
}
